import {   CLEAR_ERRORS, LOADING_UI,SET_UNAUTHENTICATED,LOADER_FALSE,
    LOADER_CHECK,ROOMTRAINING_CITY_FILTER,BUILDING_CITY_FILTER,TOWER_CITY_FILTER,
    ROOM_TRAINING_MANAGEMENT,FLOOR_CITY_FILTER,ROOM_ADD_TRAINING,EDIT_ROOM_ADD_TRAINING} from '../type';


    const initialState = {
        RoomTrainingData:[],
        loader:false,
        TrainingRoomCityData:[],
        TrainingRoomBuilding:[],
        TrainingRoomTower:[],
        TrainingRoomFloor:[],
        AddRoomResults:[],
        EditRoomResults:[]
        
    }

    export default function (state = initialState, action) {
        switch (action.type) {
            case SET_UNAUTHENTICATED:
                return initialState;
                case ROOM_TRAINING_MANAGEMENT:
                    return {
                        ...state,
                        RoomTrainingData: action.payload,
                        loading: false
                    }      
                    case ROOMTRAINING_CITY_FILTER:
                        return {
                            ...state,
                            TrainingRoomCityData: action.payload,
                            loading: false
                        } 
                    case ROOM_ADD_TRAINING:
                        return {
                            ...state,
                            AddRoomResults: action.payload,
                            loading: false
                        } 


                        case EDIT_ROOM_ADD_TRAINING:
                            return {
                                ...state,
                                EditRoomResults: action.payload,
                                loading: false
                            } 



                        case BUILDING_CITY_FILTER:
                            return {
                                ...state,
                                TrainingRoomBuilding: action.payload,
                                loading: false
                            } 
                        case TOWER_CITY_FILTER:
                            return {
                                ...state,
                                TrainingRoomTower: action.payload,
                                loading: false
                            } 
                            case FLOOR_CITY_FILTER:
                            return {
                                ...state,
                                TrainingRoomFloor: action.payload,
                                loading: false
                            }            
                    case LOADER_CHECK:
                            return {
                                ...state,
                                loader:true,
                            }
                            case LOADER_FALSE:
                                return { 
                                    ...state,                               
                                    loader:false,
                                }
               
                    default: 
                    return state;
        }
    
    
    }